module.exports = __webpack_public_path__ + "img/Ukraine.8b47574f.png";